// Libraries
import { cardAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(cardAnatomy.keys);

/**
 * Base style configuration for the card component.
 */
const baseStyle = definePartsStyle({
  container: {
    bg: 'white',
    borderRadius: 'xl',
    border: 'section',
    boxShadow:
      '0px 100px 80px rgba(195, 194, 209, 0.1), 0px 41px 33px rgba(195, 194, 209, 0.08), 0px 22px 18px rgba(195, 194, 209, 0.06), 0px 12px 10px rgba(195, 194, 209, 0.05), 0px 7px 5px rgba(195, 194, 209, 0.04), 0px 3px 5px rgba(195, 194, 209, 0.03)',
  },
});

/**
 * cardLightTable Table style configuration for the card table component.
 */
const cardLightTable = definePartsStyle({
  container: {
    padding: 3,
  },
});

const variants = {
  cardLightTable,
};
/**
 * Chakra UI card theme configuration.
 */
export const Card = defineMultiStyleConfig({ baseStyle, variants });
